import { create } from "zustand";

interface BackStore {
    backRoute: string | null;
    setBack: (route: string | null) => void;
    clearBack: () => void;
}

export const useBackStore = create<BackStore>((set) => ({
    backRoute: null,
    setBack: (route) => set({ backRoute: route }),
    clearBack: () => set({ backRoute: null }),
}));